import { BookingDetails } from "modules/BookingCommon/common/interfaces"
import { httpClient } from "utils/infrastructure/httpClient"

export function postFailedBooking(bookingDetails: BookingDetails, reason: unknown) {
    httpClient
        .post(`payment/booking/${bookingDetails.booking_hash}/failed`, {
            payment_system: bookingDetails.payment_system,
            reason,
        })
        .catch((e) => console.error(e))
}
